import {
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from '@/src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from '@/src/error/code';

/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-16 17:47:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 14:31:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/tool.ts
 */
export enum SalesChannelEditorHeaderEnum {
  promotionBarStyle = 'salesChannelEditorHeader_promotionBarStyle',
  headerStyle = 'salesChannelEditorHeader_headerStyle',
  hoverStyle = 'salesChannelEditorHeader_hoverStyle',
  scrollEffect = 'salesChannelEditorHeader_scrollEffect',
}

export enum PositionAlignment {
  TOP_OF_PAGE = 'TOP_OF_PAGE',
  UNDER_LOGO = 'UNDER_LOGO',
  UNDER_MENU = 'UNDER_MENU',
}

export enum LogoPosition {
  CENTER = 'Center',
  LEFT = 'Left',
}

export const fixedCollapse = [
  SalesChannelEditorHeaderEnum.headerStyle,
  SalesChannelEditorHeaderEnum.hoverStyle,
  SalesChannelEditorHeaderEnum.promotionBarStyle,
  SalesChannelEditorHeaderEnum.scrollEffect,
];

export const errKey = {
  height: 'heightErr',
  intervalTime: 'intervalTime',
  entranceEffect: 'entranceEffectErr',
  logoHeight: 'logoHeightErr',
  topPadding: 'topPaddingErr',
  bottomPadding: 'bottomPaddingErr',
};

export const filter = (v) => v.replace(/[^\d^\.]+/g, '');

export const generatePromotionBarStyle = () => {
  return {
    backgroundColor: '#000000',
    textColor: '#000000',
    dividerColor: '#000000',
    height: 40,
    intervalTime: '',
    entranceEffect: '',
    stickToTop: true,
  };
};

export const promotionBarStyleValidation = (style: any) => {
  const specificErr = {};
  if (!style.height) {
    specificErr[errKey.height] = [];
    specificErr[errKey.height].push(errCodesMap[999978]);
  }
  if (!style.intervalTime) {
    specificErr[errKey.intervalTime] = [];
    specificErr[errKey.intervalTime].push(errCodesMap[999978]);
  }
  // if (!style.entranceEffect) {
  //   specificErr[errKey.entranceEffect] = [];
  //   specificErr[errKey.entranceEffect].push(errCodesMap[999978]);
  // }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const generateHeaderStyle = () => {
  return {
    logoHeight: 80,
    topPadding: 16,
    bottomPadding: 16,
    positionAlignment: PositionAlignment.TOP_OF_PAGE,
    logoBarColor: {
      backgroundColor: '#000000',
      textColor: '#000000',
      dividerColor: '#B9BCBF',
      outlineColor: '#B9BCBF',
    },
    menuBarColor: {
      backgroundColor: '#000',
      textColor: '#000',
      outlineColor: '#000',
    },
  };
};

export const headerStyleValidation = (headerStyle: any) => {
  const specificErr = {
    [errKey.logoHeight]: [],
    [errKey.topPadding]: [],
    [errKey.bottomPadding]: [],
  };
  if (!headerStyle.logoHeight) {
    specificErr[errKey.logoHeight].push(errCodesMap[999978]);
  }
  if (!headerStyle.topPadding) {
    specificErr[errKey.topPadding].push(errCodesMap[999978]);
  }
  if (!headerStyle.bottomPadding) {
    specificErr[errKey.bottomPadding].push(errCodesMap[999978]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const generateHoverStyle = () => {
  return {
    logoBarColor: {
      backgroundColor: '#000000',
      textColor: '#000000',
      dividerColor: '#B9BCBF',
      outlineColor: '#B9BCBF',
    },
    menuBarColor: {
      backgroundColor: '#000',
      textColor: '#000',
      outlineColor: '#000',
    },
  };
};

export const hoverStyleValidation = (style: any) => {
  return {
    hasError: false,
    specificError: {},
    generalError: [],
  };
};

export const generateScrollEffect = () => {
  return {
    enabled: false,
    logoHeight: 40,
    topPadding: 16,
    bottomPadding: 16,
    logoBarColor: {
      backgroundColor: '#000000',
      textColor: '#000000',
      dividerColor: '#B9BCBF',
      outlineColor: '#B9BCBF',
    },
    menuBarColor: {
      backgroundColor: '#000',
      textColor: '#000',
      outlineColor: '#000',
    },
  };
};

export const scrollEffectValidation = (style: any) => {
  const specificErr = {
    [errKey.logoHeight]: [],
    [errKey.topPadding]: [],
    [errKey.bottomPadding]: [],
  };
  if (!style.logoHeight) {
    specificErr[errKey.logoHeight].push(errCodesMap[999978]);
  }
  if (!style.topPadding) {
    specificErr[errKey.topPadding].push(errCodesMap[999978]);
  }
  if (!style.bottomPadding) {
    specificErr[errKey.bottomPadding].push(errCodesMap[999978]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const promotionBarContentValidation = (item: any) => {
  const specificErr = {
    text: [],
    name: [],
    beginTime: [],
    endTime: [],
  };
  // if (!item.text) {
  //   specificErr['text'].push(errCodesMap[999978]);
  // }
  if (!item.name) {
    specificErr['name'].push(errCodesMap[999978]);
  }
  if (!item.beginDate && !item.beginTime) {
    specificErr['beginTime'].push(errCodesMap[999977]);
  }
  if (!item.endDate && !item.endTime) {
    specificErr['endTime'].push(errCodesMap[999977]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const convertDataFromServerToRedux = (res: any) => {
  const { promotionBars, header, timezone, timezoneInGmt } = res;
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    promotionBarStyle,
    headerStyle,
    hoverStyle,
    scrollEffect,
  } = header;

  const _isNew = !uuid;

  const ids = Array.isArray(promotionBars)
    ? promotionBars.map((v) => v.uuid)
    : [];

  const collapseOpen = generateCollapseOpen([...ids, ...fixedCollapse]);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    [...ids, ...fixedCollapse],
    !_isNew,
  );

  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    modifiedDate,
    createdDate,
    timezone,
    timezoneInGmt,
    uuid,
    promotionBarStyle,
    headerStyle,
    hoverStyle,
    scrollEffect,
    promotionBars,
  };
};

export const convertDataFromReduxToServer = (res: any) => {
  const header = {
    uuid: res.uuid,
    contentUuid: res.contentUuid,
    promotionBarStyle: res.promotionBarStyle,
    headerStyle: res.headerStyle,
    hoverStyle: res.hoverStyle,
    scrollEffect: res.scrollEffect,
  };
  const promotionBars = res.promotionBars;
  return {
    header,
    promotionBars: Array.isArray(promotionBars)
      ? promotionBars.map((v) => {
          if (v.isNew) {
            return {
              ...v,
              isNew: null,
              uuid: null,
            };
          } else {
            return v;
          }
        })
      : [],
  };
};
